import { render, staticRenderFns } from "./PersonalListItem.vue?vue&type=template&id=793afd80&scoped=true&"
import script from "./PersonalListItem.vue?vue&type=script&lang=js&"
export * from "./PersonalListItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonalListItem.vue?vue&type=style&index=0&id=793afd80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793afd80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VListItem,VRow,VSwitch})
